<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="group_1 flex-row">
        <span class="text_1">面试时长：</span>
        <div class="box_2 flex-row">
          <span class="text_2">请选择面试时长</span>
          <img
            class="thumbnail_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng32bb5ffc73b63ed9396c4ca5c88708cf949f1f38de2bf548b59a76f324c084d7.png"
          />
        </div>
      </div>
    </div>
    <div class="section_4 flex-col">
      <div class="text-wrapper_1 flex-col"><span class="text_3">提交</span></div>
      <div class="block_3 flex-col">
        <div class="section_5 flex-row">
          <div class="section_6 flex-col">
            <div class="image-wrapper_6 flex-col">
              <img
                class="thumbnail_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngac0e50b7c61580100b1b64bf430e763b95e73091e710bb7cfd1cb2db7ff46fe5.png"
              />
            </div>
          </div>
        </div>
        <div class="section_7 flex-row">
          <div class="block_6 flex-col">
            <div class="block_7 flex-col"></div>
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb51f4d8bf8adac0a747699d632371ee2596245a2fef5edfa2efa7919e5e2e770.png"
            />
          </div>
        </div>
        <div class="text-wrapper_5 flex-row"><span class="text_4">曹小亮个人简历.pdf</span></div>
      </div>
      <div class="block_5 flex-col">
        <div class="box_9 flex-row">
          <div class="section_8 flex-col">
            <div class="image-wrapper_7 flex-col">
              <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngac0e50b7c61580100b1b64bf430e763b95e73091e710bb7cfd1cb2db7ff46fe5.png"
              />
            </div>
          </div>
        </div>
        <div class="box_10 flex-row">
          <div class="box_11 flex-col">
            <div class="group_9 flex-col"></div>
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb51f4d8bf8adac0a747699d632371ee2596245a2fef5edfa2efa7919e5e2e770.png"
            />
          </div>
        </div>
        <div class="text-wrapper_6 flex-row"><span class="text_5">曹小亮岗位JD.pdf</span></div>
      </div>
      <div class="box_12 flex-col">
        <div class="image-wrapper_8 flex-col">
          <img
            class="thumbnail_8"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng2f8376ef072d8731ef0759ac314175f81349de65e0879cbabee91899d239e979.png"
          />
        </div>
        <div class="group_10 flex-col"></div>
        <div class="group_11 flex-col">
          <div class="image-wrapper_9 flex-col">
            <img
              class="thumbnail_9"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng01135b14fea1a6ed0f1d7a6a8f017e9925d08bd6a28672465f01adabe77a5515.png"
            />
          </div>
        </div>
        <div class="image-wrapper_10 flex-col">
          <img
            class="label_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng8e6cd64a36098966424450b0dad4bd1cc789add12a6963e32d14afbe743b5648.png"
          />
        </div>
        <div class="group_12 flex-col"></div>
        <img
          class="label_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9b1b37eae056aad59317b4268670c0f9a45fa1b35ea31ef836a3198bcdd9f047.png"
        />
        <img
          class="thumbnail_10"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng6831030b72699f6822912a3ebf6445e456d7c581ff003cb6dcf5905d08a227ff.png"
        />
      </div>
    </div>
    <div class="box_7 flex-col">
      <span class="paragraph_1">
        当没有选择面试时长/没有上传简历/上传岗位JD，点击提交时
        <br />
        【请选择面试时长】【请上传简历】【请上传岗位JD】
      </span>
      <div class="box_8 flex-col justify-end">
        <span class="text_6">提示</span>
        <span class="text_7">请选择面试时长</span>
        <div class="group_8 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_8">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />